const TopBarDropDownConstantsEn = {
  TopBarDropDownManageProfile: 'Manage Profile',
  ViewAllNotificationsLinkText: 'View all notifications',
  NoUnreadNotificationsMessage: 'No new notifications'
};

export default TopBarDropDownConstantsEn;
